import React, { useEffect, useState } from "react";
import HolidayCalendarListing from "./HolidayCalendarListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setItems,
  setTotalItems,
  setIsTableLoading
} from "src/redux/slices/HolidayCalendarSlice";
import AddHolidayCalendarFormWrapper from "../Add/AddHolidayCalendarFormWrapper";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { useGetHolidayCalendarPaginationQuery , useDeleteHoliDayMutation } from "src/services/HolidayCalendarServices";
import { showToast } from "src/utils/showToaster";
import { Chip } from "@mui/material";
import EditHolidayCalendarFormWrapper from "../Edit/EditHolidayCalendarFormWrapper";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";
type Props = {};

const HolidayCalendarListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {items , totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.HoliDayCalendar);
  const [isOpenAddFrom, setIsOpenAddForm] = useState(false);
  const [isOpenEditFrom, setIsOpenEditForm] = useState(false);
  const [holidayId, setHolidayId] = useState("");


  const [deleteHoliDay] = useDeleteHoliDayMutation()

  const { data, isLoading, isFetching } = useGetHolidayCalendarPaginationQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["holidayName", "year", "month", "date", "branchId"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  const getActionOptions = (row: any) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setIsOpenEditForm(true)
          setHolidayId(row?._id) },
          actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.HOLIDAY_CALENDAR

      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Holiday Calendar ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result.isConfirmed) { 
                deleteHoliDay(row?._id).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.HOLIDAY_CALENDAR
      },
    ];
  };

 
  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
      dispatch(setIsTableLoading(false));
    } else {
      dispatch(setIsTableLoading(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    {
      field: "date",
      headerName: "Date",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {`${row?.date} ${row?.month}  ${row?.year}`} </span>,
    },
    {
      field: "holidayName",
      extraClasses : 'py-2',
      headerName: "Holiday Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row?.holidayName} </span>,
    }, 
    {
      field: "branchId",
      headerName: " Branch Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => {
        return row?.branchId?.map((branch: any) => {
              return <Chip label={branch?.branchName} key={branch?._id} className="me-2 my-2" />;
            })
      },
    },
    {
      field: "optional",
      headerName: "Optional",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row.optional ? 'YES' :'NO'} </span>,
    },
    {
      noAuthRequired: true,
      field: "action",
      headerName: "Action",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      <HolidayCalendarListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.HOLIDAY_CALENDAR,
          actionName: UserModuleActionTypes.LIST,
          columns: columns
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onAddNew={() => setIsOpenAddForm(true)}
      />
      {isOpenAddFrom ? (
        <AddHolidayCalendarFormWrapper
          onClose={() => setIsOpenAddForm(false)}
        />
      ) : null} 

      {isOpenEditFrom ?( <EditHolidayCalendarFormWrapper    holidayId={holidayId} onClose={() => setIsOpenEditForm(false)}
        />
      ) : null}
    </div>
  );
};

export default HolidayCalendarListingWrapper;
